<template>
  <section class="mb-5">
    <h3 class="text-center text-tertiary">Appointment: {{ startFormatted }}</h3>
    <div v-if="error" class="alert alert-danger alert-icon" role="alert">
        <div class="alert-content">
            <p>{{ error }}</p>
        </div>
    </div>
    <table class="table">
        <thead>
          <tr class="text-black bg-form">
            <th class="w-25">Time</th>
            <th class="w-25">Pet</th>
            <th class="w-25">Resource</th>
            <th class="w-25">Status</th>
          </tr>
        </thead>
        <tbody>
          <row-desktop v-for="appointment in scheduleAppointments"
            :key="appointment.id"
            :appointment="appointment"
            :pets="schedulePets"
            :resources="scheduleResources"
            :time-format="momentJSTimeFormat"/>
        </tbody>
    </table>
  </section>
</template>

<script>
import moment from 'moment-timezone'
import { mapState } from 'vuex'
import { ScheduleAppointmentsCacheMixin } from '@/mixins/Appointment/ScheduleAppointmentsCacheMixin'
import { ScheduleResourcesCacheMixin } from '@/mixins/Appointment/ScheduleResourcesCacheMixin'
import { SchedulePetsCacheMixin } from '@/mixins/Appointment/SchedulePetsCacheMixin'
import { DateFormatMixin } from '@/mixins/Format/DateFormatMixin'
import { TimeFormatMixin } from '@/mixins/Format/TimeFormatMixin'
import { TimeZoneCacheMixin } from '@/mixins/Shared/TimeZoneCacheMixin'
import AppointmentDesktopRow from './AppointmentDesktopRow.vue'

export default {
  name: 'Appointments',
  mixins: [DateFormatMixin, TimeFormatMixin, TimeZoneCacheMixin, ScheduleAppointmentsCacheMixin, ScheduleResourcesCacheMixin, SchedulePetsCacheMixin],
  computed: {
    ...mapState('TimeZone', [
      'selectedTimeZoneId'
    ]),
    appointment () {
      return this.scheduleAppointments.find(a => a)
    },
    startUtc () {
      return this.appointment ? this.appointment.startUtc : ''
    },
    startFormatted () {
      return this.startUtc ? moment.tz(this.startUtc, this.selectedTimeZoneId).format(this.momentJSDateFormat) : ''
    }
  },
  components: {
    'row-desktop': AppointmentDesktopRow
  }
}
</script>
